import { createContext, useContext } from 'react';

export interface LayoutContextValue {
    isMobile: boolean;
    openNavigation?: () => void;
    subHeaderSlot: HTMLElement | null;
    setSubHeaderSlot: (element: HTMLElement | null) => void;
}

const LayoutContext = createContext<LayoutContextValue | null>(null);

export const LayoutContextProvider = LayoutContext.Provider;

export const useLayoutContext = () => useContext(LayoutContext);
